import {LocationVendor} from "../../../config/location";

export const LOCATION_VENDOR = {
    [LocationVendor.LOCAL_COMPANY]: 'Local',
    [LocationVendor.IMPORT]: 'Import',
    [LocationVendor.GOOGLE_MAPS]: 'Google Maps',
    [LocationVendor.MANUAL_INPUT]: 'Manual',
};
